import styles from "./SectionTitle.module.css";

function SectionTitle({ title, tabs = [], activeTab, onTabClick }) {
  if (tabs.length > 0) {
    return (
      <div className={styles.tabSection}>
        <div className={styles.sectionLabel}>Explore</div>
        <div className={styles.tabTitleContainer}>
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              className={`${styles.tabTitle} ${
                activeTab === tab ? styles.active : styles.inactive
              }`}
              onClick={() => onTabClick(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={styles.sectionHeading}>
      <div className={styles.sectionLabel}>Section</div>
      <div className={styles.sectionTitle}>{title}</div>
    </div>
  );
}

export default SectionTitle;
